/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {MarkWidgetAsUsedRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/widget_service.pb'
import {MarkWidgetAsUsedResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/widget_service.pb'


export const markWidgetAsUsed = (request: MarkWidgetAsUsedRequest, options?: CashRequestOptions) => post<MarkWidgetAsUsedRequest, MarkWidgetAsUsedResponse>("/2.0/cash/mark-widget-as-used", request, {...options, rejectOnError: true })